import Link from 'next/link'
import cn from 'classnames'

import styles from './styles.module.scss'

export const LinkButton = ({
  title,
  path,
  onClick,
  className,
  wrapperStyle,
}: {
  title: string
  path?: string
  onClick?: () => void
  className?: string
  wrapperStyle?: string
}) => {
  return (
    <div
      className={cn(styles.buttonWrapper__button, { [styles.buttonWrapper__button__click]: onClick }, wrapperStyle)}
      onClick={onClick}
    >
      {path && (
        <Link href={path}>
          <a className={cn(styles.buttonWrapper__link, className)}>{title}</a>
        </Link>
      )}
      {onClick && (
        <div>
          <div className={cn(styles.buttonWrapper__link, className)}>{title}</div>
        </div>
      )}
    </div>
  )
}
